// ============================================
// CHÁMOMILE - Product Data
// ============================================

import { Product } from '../types';

export const products: Product[] = [
  {
    id: '1',
    name: 'Lavender Lullaby',
    imageUrl: 'https://i.imgur.com/oSJtYcs.png',
    price: 13,
    description: 'Soothing lavender with creamy oatmilk',
  },
  {
    id: '2',
    name: 'Gentle Chamomile',
    imageUrl: 'https://i.imgur.com/xi0bRZT.png',
    price: 13,
    description: 'Classic chamomile tea blend',
  },
  {
    id: '3',
    name: 'Lychee Rosette',
    imageUrl: 'https://i.imgur.com/zamM3wD.png',
    price: 13,
    description: 'Sweet lychee with floral notes',
  },
  {
    id: '4',
    name: 'Sun-Kissed Peach',
    imageUrl: 'https://i.imgur.com/H12UWmK.png',
    price: 13,
    description: 'Refreshing peach infusion',
  },
  {
    id: '5',
    name: 'Moonlit Jasmine',
    imageUrl: 'https://i.imgur.com/iZhx5QO.png',
    price: 13,
    description: 'Fragrant jasmine tea blend',
  },
  {
    id: '6',
    name: 'Blushing Berry',
    imageUrl: 'https://i.imgur.com/PCW1EOn.png',
    price: 14,
    description: 'Mixed berry delight',
  },
];

export const COLLECTION_TIMES = [
  '10:00 AM',
  '11:00 AM',
  '12:00 PM',
  '1:00 PM',
  '2:00 PM',
  '3:00 PM',
  '4:00 PM',
  '5:00 PM',
  '6:00 PM',
  '7:00 PM',
  '8:00 PM',
  '9:00 PM',
  '10:00 PM',
];

export const PICKUP_LOCATION = {
  name: 'Forest Hill Residences',
  address: 'Kota Kinabalu, Sabah',
  hours: '10:00 AM - 10:00 PM daily',
};

export const BANK_DETAILS = {
  accountName: 'Chamomile',
  accountNumber: '5601 0270 7392',
  bankName: 'Maybank',
};

export const WHATSAPP_NUMBER = '60108202187';
